"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TranslationKey = require("./TranslationKey");
Object.keys(_TranslationKey).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationKey[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationKey[key];
    }
  });
});
var _ProductBoxMode = require("./ProductBoxMode");
Object.keys(_ProductBoxMode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductBoxMode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductBoxMode[key];
    }
  });
});
var _net = require("./graphql-types/net");
Object.keys(_net).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _net[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _net[key];
    }
  });
});
//# sourceMappingURL=index.js.map